declare global {
  interface Window { onArkoseLoad: Function; }
}

export const loadArkoseCdnScript = (publicApiKey: string, onArkoseLoad: Function) => {
  const script = document.createElement('script');
  script.src = `//client-api.arkoselabs.com/v2/${publicApiKey}/api.js`;
  script.async = true;
  script.defer = true;
  window.onArkoseLoad = onArkoseLoad;
  script.setAttribute('data-callback', 'onArkoseLoad');
  document.body.appendChild(script);
};
